export default __webpack_public_path__ + "static/media/Remove.ecfbe1a9.svg";